import { DC } from "../../constants";
import wordShift from "../../word-shift";

export const pelleRifts = {
  vacuum: {
    id: 1,
    key: "vacuum",
    name: ["Вакуум", "Полость", "Пустота"],
    drainResource: "ОБ",
    baseEffect: x => `Заработок ОБ ${formatX(x, 2, 2)}`,
    additionalEffects: () => [PelleRifts.vacuum.milestones[2]],
    strike: () => PelleStrikes.infinity,
    percentage: totalFill => Math.log10(totalFill.plus(1).log10() * 10 + 1) ** 2.5 / 100,
    percentageToFill: percentage => Decimal.pow(10,
      Decimal.pow(10, (percentage * 100) ** (1 / 2.5)).div(10).minus(0.1)
    ).minus(1),
    effect: totalFill => {
      if (player.challenge.eternity.current !== 0) {
        const chall = EternityChallenge.current;
        const goal = chall.goalAtCompletions(chall.gainedCompletionStatus.totalCompletions);
        return totalFill.plus(1).pow(0.1).min(goal.pow(0.15));
      }
      return totalFill.plus(1).pow(0.33);
    },
    currency: () => Currency.infinityPoints,
    galaxyGeneratorThreshold: 1000,
    milestones: [
      {
        resource: "vacuum",
        requirement: 0.04,
        description: "Вы можете экипировать один базовый Глиф с уменьшенным уровнем и редкостью"
      },
      {
        resource: "vacuum",
        requirement: 0.06,
        description: () => `Снять Ограничение Репликантов и удешевить их разблокировку и улучшения ${formatX(1e130)}`,
        effect: () => 1e130
      },
      {
        resource: "vacuum",
        requirement: 0.4,
        description: () => `${wordShift.wordCycle(PelleRifts.vacuum.name)} также влияет на заработок ОВ`,
        effect: () => Decimal.pow(4, PelleRifts.vacuum.totalFill.log10() / 2 / 308 + 3),
        formatEffect: x => `Заработок ОВ ${formatX(x, 2, 2)}`
      },
    ],
    galaxyGeneratorText: "Свободного места больше не осталось, вы должны заполнить $value"
  },
  decay: {
    id: 2,
    key: "decay",
    name: ["Распад", "Коллапс", "Смятение"],
    drainResource: "Репликанты",
    spendable: true,
    baseEffect: x => `Скорость Репликантов ${formatX(x, 2, 2)}`,
    additionalEffects: () => [PelleRifts.decay.milestones[0], PelleRifts.decay.milestones[2]],
    strike: () => PelleStrikes.powerGalaxies,
    // 0 - 1
    percentage: totalFill => totalFill.plus(1).log10() * 0.05 / 100,
    // 0 - 1
    percentageToFill: percentage => Decimal.pow(10, 20 * percentage * 100).minus(1),
    effect: totalFill => (PelleRifts.chaos.milestones[0].canBeApplied
      ? Decimal.sqrt(2000 + 1) : Decimal.sqrt(totalFill.plus(1).log10() + 1)),
    currency: () => Currency.replicanti,
    galaxyGeneratorThreshold: 1e7,
    milestones: [
      {
        resource: "decay",
        requirement: 0.2,
        description: "Первое многоразовое улучшение Пелле также влияет на 1ое Измерение Бесконечности",
        effect: () => {
          const x = player.celestials.pelle.rebuyables.antimatterDimensionMult;
          return Decimal.pow(1e50, x - 9);
        },
        formatEffect: x => `1ое Измерение Бесконечности ${formatX(x, 2, 2)}`
      },
      {
        resource: "decay",
        requirement: 0.6,
        description: () => `Когда Репликанты превышают ${format(DC.E1300)},
          все Галактики на ${formatPercents(0.1)} более эффективны`,
        effect: () => (Replicanti.amount.gt(DC.E1300) ? 1.1 : 1)
      },
      {
        resource: "decay",
        requirement: 1,
        description: "Повысить максимальное количество Галактик Репликантов на основе рубежей Разлома",
        effect: () => {
          const x = PelleRifts.totalMilestones();
          return x ** 2 - 2 * x;
        },
        formatEffect: x => `Макс количество ГР +${formatInt(x)}`
      },
    ],
    galaxyGeneratorText: "Недостаточно антиматерии для формирования новых Галактик, необходимо обратить вспять $value"
  },
  chaos: {
    id: 3,
    key: "chaos",
    name: ["Хаос", "Беспорядок", "Нечистоты"],
    drainResource: ["Распад", "Коллапс", "Смятение"],
    baseEffect: x => `Time Dimensions ${formatX(x, 2, 2)}`,
    strike: () => PelleStrikes.eternity,
    percentage: totalFill => totalFill / 10,
    percentageToFill: percentage => 10 * percentage,
    effect: totalFill => {
      const fill = totalFill > 6.5
        ? (totalFill - 6.5) / 7 + 6.5
        : totalFill;
      return Decimal.pow(6, Decimal.pow(6, Decimal.pow(6, fill / 10 + 0.1)).minus(6))
        .div(1e5)
        .plus(Decimal.pow(10, fill / 10 + 0.1));
    },
    currency: () => ({
      get value() {
        return PelleRifts.decay.percentage;
      },
      set value(val) {
        const spent = PelleRifts.decay.percentage - val;
        player.celestials.pelle.rifts.decay.percentageSpent += spent;
      }
    }),
    galaxyGeneratorThreshold: 1e9,
    milestones: [
      {
        resource: "chaos",
        requirement: 0.09,
        description: () => `${wordShift.wordCycle(PelleRifts.decay.name)} \
        эффект всегда максимизирован и рубежи всегда активны`
      },
      {
        resource: "chaos",
        requirement: 0.15,
        description: "Глифы получают новый особенный для Пелле эффект",
      },
      {
        resource: "chaos",
        requirement: 1,
        description: () => `Вы зарабатываете ${formatPercents(0.01)} ваших ОВ, полученных на Вечности в секунду`,
      },
    ],
    galaxyGeneratorText: "Ваши Галактики слишком раздроблены, вы должны стабилизировать $value"
  },
  recursion: {
    id: 4,
    key: "recursion",
    name: ["Рекурсия", "Дисперсия", "Разрушение"],
    drainResource: "ОВ",
    baseEffect: x => `Формула ОВ: log(x)/${formatInt(308)} ➜ log(x)/${formatFloat(308 - x.toNumber(), 2)}`,
    additionalEffects: () => [PelleRifts.recursion.milestones[0], PelleRifts.recursion.milestones[1]],
    strike: () => PelleStrikes.ECs,
    percentage: totalFill => totalFill.plus(1).log10() ** 0.4 / 4000 ** 0.4,
    percentageToFill: percentage => Decimal.pow(10, percentage ** 2.5 * 4000).minus(1),
    effect: totalFill => new Decimal(58 * totalFill.plus(1).log10() ** 0.2 / 4000 ** 0.2),
    currency: () => Currency.eternityPoints,
    galaxyGeneratorThreshold: 1e10,
    milestones: [
      {
        resource: "recursion",
        requirement: 0.10,
        description: "Бусты Измерений более мощные на основе прохождений ВЧ",
        effect: () => Math.max(100 * EternityChallenges.completions ** 2, 1) *
          Math.max(1e4 ** (EternityChallenges.completions - 40), 1),
        formatEffect: x => `Степень Бустов Измерений ${formatX(x, 2, 2)}`
      },
      {
        resource: "recursion",
        requirement: 0.15,
        description: "Измерения Бесконечности сильнее на основе прохождений ВЧ",
        effect: () => Decimal.pow("1e1500", ((EternityChallenges.completions - 25) / 20) ** 1.7).max(1),
        formatEffect: x => `Измерения Бесконечности ${formatX(x)}`
      },
      {
        resource: "recursion",
        requirement: 1,
        description: "Навсегда разблокировать Генератор Галактик",
      },
    ],
    galaxyGeneratorText: "Создание большего количества Галактик неустойчиво, вы должны сфокусировать $value чтобы " +
      "создавать больше"
  },
  paradox: {
    id: 5,
    key: "paradox",
    name: ["Парадокс", "Противоречие", "Заблуждение"],
    drainResource: "Растянутое Время",
    baseEffect: x => `Все Измерения ${formatPow(x, 2, 3)}`,
    additionalEffects: () => [PelleRifts.paradox.milestones[2]],
    strike: () => PelleStrikes.dilation,
    percentage: totalFill => totalFill.plus(1).log10() / 100,
    percentageToFill: percentage => Decimal.pow10(percentage * 100).minus(1),
    effect: totalFill => new Decimal(1 + totalFill.plus(1).log10() * 0.004),
    currency: () => Currency.dilatedTime,
    galaxyGeneratorThreshold: 1e5,
    milestones: [
      {
        resource: "paradox",
        requirement: 0.15,
        description: "Измерения Времени 5-8 гораздо более дешевые, разблокируется больше улучшений Растяжения",
        // FIXME: Not a great solution
        onStateChange: () => {
          updateTimeDimensionCosts();
        }
      },
      {
        resource: "paradox",
        requirement: 0.25,
        description: () => `Заработок Растянутого Времени становится Тахион Частицами ${formatPow(1.4, 1, 1)}`,
        effect: 1.4
      },
      {
        resource: "paradox",
        requirement: 0.5,
        description: "Количество многоразовых покупок Растяжения улучшает уровень конвертации Мощности Бесконечности",
        effect: () => Math.min(
          1.1075 ** (Object.values(player.dilation.rebuyables).sum() - 60),
          712
        ),
        formatEffect: x => `Конвертация Мощности Бесконечности ${formatX(x, 2, 2)}`
      },
    ],
    galaxyGeneratorText: "Теперь можно создавать больше, но Пелле ограничил вас. Пренебречь $value"
  }
};
